import React, { useState } from "react";
import "./header.css";
import logo from "./logo.png";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="containerB">
      <div className="top-bar">
  <div className="top-bar-contact">
    <FaPhoneAlt className="top-icon" />
    <a href="tel:+254733372788">+254 733 372 788</a>

    <span className="divider">|</span>

    <FaEnvelope className="top-icon" />
    <a href="mailto:livamcompany@gmail.com">
      livamcompany@gmail.com
    </a>
  </div>
</div>
      <nav className="navbar">
      <div className="navbar-logo">
  <img src={logo} alt="Livam Solutions Limited" className="logo" />

  <div className="company-info">
    <div className="company-name">
      Livam Solutions Ltd
    </div>

    <div className="tagline">
      Water for Today, Sustainability for Tomorrow
    </div>
  </div>
</div>
        <button
          className={`menu-toggle ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span className={`menu-icon ${isOpen ? "open" : ""}`}>
            {isOpen ? "✖" : "☰"}
          </span>
        </button>

        <ul className={`navbar-links ${isOpen ? "open" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>

          <li>
            <Link to="/about" onClick={closeMenu}>About</Link>
          </li>

          <li>
            <Link to="/services" onClick={closeMenu}>Services</Link>
          </li>

          <li>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
          </li>

          <li>
            <Link to="/gallery" onClick={closeMenu}>Our Gallery</Link>
          </li>

          <li>
            <Link to="/blog" onClick={closeMenu}>Blog</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Header;